import * as httpClient from '../clients/httpClient'

const ERROR_MESSAGES = {
  BAD_REQUEST: 'Bad request.',
  SERVICE_ERROR: 'Service error.'
}

const putCompanySettings = async ({ companyId, annualRevenue, employeeCount, hasTippedEmployees, industry }) => {
  const jsonResponse = await httpClient.getJsonResponse({
    path: `/companies/${companyId}`,
    body: {
      _id: companyId,
      annualRevenue,
      employeeCount,
      hasTippedEmployees,
      industry
    },
    method: 'PATCH'
  })

  if (jsonResponse.statusCode >= 400 && jsonResponse.statusCode < 500) {
    console.error('BAD_REQUEST error in putCompanySettings', jsonResponse.body)
    throw new Error((jsonResponse.body && jsonResponse.body.error) || ERROR_MESSAGES.BAD_REQUEST)
  }

  if (jsonResponse.statusCode >= 500 && jsonResponse.statusCode < 600) {
    console.error('INTERNAL_SERVER error in putCompanySettings', jsonResponse.body)
    throw new Error((jsonResponse.body && jsonResponse.body.error) || ERROR_MESSAGES.SERVICE_ERROR)
  }

  return jsonResponse.body.data
}

module.exports = {
  ERROR_MESSAGES,
  putCompanySettings
}
